export default __webpack_public_path__ + "static/media/grey-star-v2.c9915a2e84b18b7710f69bcdb11d5ed9.svg";